<kpi-host #callToActionAHost [title]="'Prioridad'" [refreshing]="loading" [warn]="warn"
    [lastUpdatedText]="lastUpdatedText" [size]="3" [hostsTable]="true">

    <i icon class="material-icons">people</i>

    <kpi-host-menu-option menuOption [text]="'Actualizar'" (click)="refresh()"></kpi-host-menu-option>
    <kpi-host-menu-option menuOption [text]="'Exportar'" (click)="exportCSVFile()"></kpi-host-menu-option>

    <ng-container additionalData>
        <br />
        <!-- TABLA DE DATOS DE BUCKETS -->
        <div>
            <table class="table table-randstad table-bordered table-hover table-bucket">
                <thead>
                    <tr>
                      @for (columnDefinition of columnDefinitions || []; track $index; let i = $index) {
                        <th [attr.colspan]="columnDefinition.colspan" style="padding: 6px; text-align: center;">
                          <div [ngClass]="{'styleHeaderFlex': columnDefinition.center == false}"
                            (click)="sortData(columnDefinition)">
                            <span class="styleHeader">{{columnDefinition.title}}</span>
                            <i [hidden]="!(columnDefinition.sortable && columnDefinition.sortType == columnSort.Asc)"
                                class="material-icons"
                                style="vertical-align: middle !important; line-height: 18px; cursor: pointer;">arrow_drop_up</i>
                            <i [hidden]="!(columnDefinition.sortable && columnDefinition.sortType == columnSort.Desc)"
                              class="material-icons"
                              style="vertical-align: middle !important; line-height: 18px; cursor:pointer;">arrow_drop_down</i>
                            <div [hidden]="!(columnDefinition.sortable && columnDefinition.sortType == columnSort.None)"
                              style="display:flex; flex-direction:column; color:lightgray; cursor: pointer;">
                              <i class="material-icons"
                                  style="vertical-align: middle !important; line-height: 8px;">arrow_drop_up</i>
                              <i class="material-icons"
                                  style="vertical-align: middle !important; line-height: 4px;">arrow_drop_down</i>
                            </div>
                          </div>
                        </th>
                      }
                    </tr>
                </thead>
                <tbody>
                  @if (summaryData) {
                    @for (bucket of bucketsPagination[paginationParams.currentIndex]; track $index; let i = $index) {
                      <tr>
                          <td>{{bucket.name}}</td>
                          <td>{{bucket.branchName}}</td>
                          <td style="color: #e74537;">{{bucket.neededToFill}}</td>
                          <td>{{bucket.nCandidates}}</td>
                          <td style="color: #b8d001">{{bucket.historicalWorkersCount}}</td>
                          <td>{{bucket.cvNotRead}}</td>
                          <td>{{bucket.pendingOrders}}</td>
                          <td>{{bucket.pendingOrdersLastWeek}}</td>
                          <td>
                              <div id="{{i}}" ngbDropdown #cardMenu="ngbDropdown" class="dropdown" [autoClose]="true"
                                  style="position: relative;"
                                  (click)="$event.stopPropagation(); clearSelectedActions(i)">
                                  <a class="dropdown-toggle dropdown-toggle-more" role="button" id="dropdownMenuLink"
                                      ngbDropdownToggle aria-haspopup="true" aria-expanded="false"
                                      [hidden]="false">
                                      <i class="ico-dots"></i>
                                  </a>
                                  <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuLink">
                                      <button id="p1" class="dropdown-item" (click)="viewFill(bucket)">¿Necesitas
                                          rellenar?</button>
                                      <button id="p2" class="dropdown-item" (click)="viewHistory(bucket)">Mostrar
                                          históricos</button>
                                      <button id="p3" class="dropdown-item" (click)="viewWorker(bucket)">Ir a Work
                                          Process</button>
                                  </div>
                              </div>
                          </td>
                      </tr>
                    }
                  }

                  @if (!summaryData && !summaryError) {
                    <tr>
                      <td colspan="9" class="text-center">
                        <br />
                        <p style="margin-left:auto;">¡Buen trabajo!</p>
                        <i class="far fa-thumbs-up" style="margin-left: 5px; margin-right: auto;"></i>
                      </td>
                      </tr>
                  }
                </tbody>
            </table>
        </div>
        <!-- Paginación -->
         @if (buckets) {
          <div class="pagination justify-content-center">
            <ngb-pagination [collectionSize]="buckets.length" [pageSize]="paginationParams.pageMaxSize"
                [page]="paginationParams.currentPage" [maxSize]="10" [rotate]="true" [ellipses]="true"
                [boundaryLinks]="true" (pageChange)="pagination($event)" class="text-center">
            </ngb-pagination>
          </div>
         }
    </ng-container>

    @if (summaryData) {
      <i additionalData class="icon icon-home"></i>
    }

    @if (summaryError) {
      <data-error errorMsg [errorMessage]="summaryError.message" (onRequestRefresh)="refresh()">
      </data-error>
    }
</kpi-host>
